var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"container"},[_c('div',{staticClass:"content-container"},[_c('router-view',{attrs:{"language":_vm.language}})],1),_c('footerContainer'),(_vm.isPicUpload)?_c('picUpload'):_vm._e(),(_vm.isFaceUpload)?_c('faceUpload'):_vm._e(),(_vm.isVoiceUplaod)?_c('voiceRec'):_vm._e()],1)
}
var staticRenderFns = []

export { render, staticRenderFns }